import React from "react";
import { motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import CustomInput from "Common/CustomInput/CustomInput";
import SuperAccordion from "Components/SuperAccordion/SuperAccordion";
import PropTypes from "prop-types";

const GroupInformation = ({
  planData,
  planIndex,
  insuranceSectionsOpen,
  onToggleInsuranceSection,
  handleChange,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="border rounded-lg p-4"
    >
      <div
        className="flex items-center justify-between cursor-pointer py-2"
        onClick={() => onToggleInsuranceSection("group")}
      >
        <h3 className="text-lg font-medium text-gray-900">
          Group Information
        </h3>
        {insuranceSectionsOpen.group ? (
          <FiChevronUp className="text-gray-500" />
        ) : (
          <FiChevronDown className="text-gray-500" />
        )}
      </div>
      <SuperAccordion show={insuranceSectionsOpen.group}>
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6">
            <CustomInput
              onChange={handleChange}
              name="groupNumber"
              data-nested={`patientPlan.${planIndex}.groupNumber`}
              value={planData?.groupNumber}
              label="Group #"
              placeholder="Group #"
            />
          </div>
          <div className="col-span-12 md:col-span-6">
            <CustomInput
              onChange={handleChange}
              name="groupName"
              data-nested={`patientPlan.${planIndex}.groupName`}
              value={planData?.groupName}
              label="Group Name"
              placeholder="Group Name"
            />
          </div>
        </div>
      </SuperAccordion>
    </motion.div>
  );
};

GroupInformation.propTypes = {
  planData: PropTypes.object,
  planIndex: PropTypes.number.isRequired,
  insuranceSectionsOpen: PropTypes.object.isRequired,
  onToggleInsuranceSection: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default GroupInformation;
